/** File names and MIME types of uploaded files. */

const EXTENSION_TO_MIME_TYPE: Record<string, string> = {
  jpg: 'image/jpeg',
  jpeg: 'image/jpeg',
  png: 'image/png',
  gif: 'image/gif',
  webp: 'image/webp',
  heic: 'image/heic',
  tif: 'image/tiff',
  tiff: 'image/tiff',
  avif: 'image/avif',
  bmp: 'image/bmp',
  pdf: 'application/pdf',
  mp4: 'video/mp4',
  mov: 'video/quicktime',
  mkv: 'video/x-matroska',
  webm: 'video/webm'
};

const IMAGE_EXTENSIONS = [
  'jpg',
  'jpeg',
  'png',
  'gif',
  'webp',
  'heic',
  'tif',
  'tiff',
  'avif',
  'bmp'
];

export function getFileExtension(fileName: string): string | undefined {
  return fileName.split('.').pop()?.toLowerCase();
}

/** Whether the name looks like an image's, by its extension. */
export function isImageFile(fileName: string): boolean {
  const extension = getFileExtension(fileName);
  return extension ? IMAGE_EXTENSIONS.includes(extension) : false;
}

/** The file's own MIME type, else one inferred from its name, else a binary one. */
export function determineMimeType(file: {
  name: string;
  mimeType?: string;
}): string {
  if (file.mimeType) return file.mimeType;
  const extension = getFileExtension(file.name);
  return (
    (extension && EXTENSION_TO_MIME_TYPE[extension]) ||
    'application/octet-stream'
  );
}
